module.exports = __webpack_public_path__ + "static/full_logo-62d011045bc57da60f198a476c7d7709.png";